/*
 * @Descripttion:
 * @version:
 * @Author: sueRimn
 * @Date: 2020-05-24 13:59:41
 * @LastEditors: dandan.Wu
 * @LastEditTime: 2021-03-30 10:14:26
 */
const apiUrl =
  process.env.NODE_ENV == 'development'
    ? '/api/'
    : 'https://mp.api.mgtv.com/api/'

const apiUrlDm = 'https://damang.api.mgtv.com/'

export const applyURI = apiUrl + 'user/settled/outside/personApply'

/** 视频 **/
export const delVideoURI = apiUrl + 'video/outside/deleteVideos' //删除视频

export const timerPubVideoURI = apiUrl + 'video/outside/timerPublishVideo' //定时发布视频

export const pubVideoURI = apiUrl + 'video/outside/publishVideo' //发布视频

export const dePubVideoURI = apiUrl + 'video/outside/dePublishVideos' //取消发布(下线)视频

// export const getVideoListURI = apiUrl + 'video/outside/getUserVideoList' //获取用户视频列表
export const getVideoListURI = apiUrlDm + 'admin/video/list' //获取用户视频列表

export const delTimerPubVideoURI = apiUrl + 'video/outside/deTimerPublishVideo' //取消定时发布

export const getVideoLogsURI = apiUrl + 'video/outside/getVideoLogs' //查看不通过原因

export const getBannerConfig = '/banner/conf' // 闪图

/** 播单 **/
export const getUserPlaylistURI = apiUrl + 'playlist/outside/getUserPlayist' //获取用户播单列表

export const addPlaylistURI = apiUrl + 'playlist/outside/addPlaylist' // 新增保存播单

export const deletePlaylistURI = apiUrl + 'playlist/outside/deletePlaylists' //删除播单

export const pubPlaylistURI = apiUrl + 'playlist/outside/publishPlaylist' //发布播单

export const delPubPlaylistURI = apiUrl + 'playlist/outside/dePublishPlaylist' //取消发布播单

export const getPlayLogsURI = apiUrl + 'playlist/outside/getPlayLogs' //查看不通过原因

export const delPlayVideosURI = apiUrl + 'playlist/outside/deletePlayVideos' //移除播单视频

export const insertOrUpdatePlayVideosURI =
  apiUrl + 'playlist/outside/insertOrUpdatePlayVideos' //新增or更新播单视频

export const updatePlayVideosURI =
  apiUrl + 'playlist/outside/insertOrUpdatePlayVideos' //新增or更新播单视频

export const getVideosByPlidURI = apiUrl + 'playlist/outside/getVideosByPlid' //根据播单id获取关联视频

/** 用户 **/
// export const getColumnistInfoUrl = apiUrl + 'user/outside/getColumnistInfo' // 用户信息

export const getColumnistInfoUrl = apiUrlDm + 'admin/up/info' // 用户信息
export const getColumnistInfoUrlNew =
  apiUrlDm + 'admin/creator/center/data/base' // 用户信息 播放次数、点赞数 等

//阿里云上传图片token
// export const getStsToken = '//upload-ugc.bz.mgtv.com/upload/image/getStsToken'
export const getStsToken = apiUrlDm + '/admin/upload/stsToken'

//腾讯云上传视频token
// export const getWebSdkSignature =
//   '//upload-ugc.bz.mgtv.com/upload/video/getWebSdkSignature'
export const getWebSdkSignature = apiUrlDm + 'admin/video/cloud/getStsToken'

//获取分类
export const getClassIfy = '//vtag.api.mgtv.com/tag/l1tag2'

// 获取分类分区
// export const getTypeAreaList = apiUrl + 'vtag/outside/selectTypeAreaList'
export const getTypeAreaList = apiUrlDm + 'admin/video/getTagAreaList'

// 获取标签
export const getTagListUrl = apiUrl + 'vtag/outside/getClassTagsByAreaId'

// 获取相关明星、相关合集
export const getTagsByNameUrl = apiUrl + 'vtag/outside/getTagsByName'

//获取标签
export const getTag = '//vtag.api.mgtv.com/tag/l2tag2'

export const getActList = apiUrl + 'video/outside/getActList' //获取活动

export const getActListUrl = apiUrl + 'video/outside/getActList' //获取活动

export const getActTypeListUrl = apiUrl + 'video/outside/getActTypeList' //获取活动分类

export const getPlanList = apiUrl + 'video/outside/getPlanList' //获取计划

// export const saveVideos = apiUrl + 'video/outside/saveVideos' //发布视频
export const saveVideos = apiUrlDm + 'admin/video/upload/proxy/video/create' //发布视频

// 获取默认封面
export const GenerateSnapshot = apiUrl + 'video/outside/GenerateSnapshot' //获取默认封面
export const GenerateSnapshotNew = '//upload.api.mgtv.com/media/getSnapshot' //获取默认封面

// 帮助中心
export const helpListURI = apiUrl + 'question/outside/getSysQAList' // 获取帮助中心问题列表

// 实名认证
// export const setVerifiURI = apiUrl + 'cert/outside/settled/verification' // 实名认证接口
export const setVerifiURI = apiUrlDm + 'admin/up/verified' // 实名认证接口
// export const getCertifiUserInfoURI =
//   apiUrl + 'cert/outside/certification/userInfo' // 获取实名认证用户信息
export const getCertifiUserInfoURI = apiUrlDm + 'admin/up/settle/info' // 获取实名认证用户信息
export const getSettedUserInfoURI = apiUrl + 'cert/outside/settled/userInfo' // 个人入驻页面个人基本信息获取
// export const setSettedPersonURI = apiUrl + 'cert/outside/settled/person' // 个人信息完善
export const setSettedPersonURI = apiUrlDm + 'admin/up/base/info/update' // 个人信息完善
// 改 admin/up/base/info/update
export const getVerifiStatusURI = apiUrl + 'cert/outside/verification/status' // 获取实名认证状态
export const getrejectInfoURI =
  apiUrl + 'cert/outside/certification/rejectUserInfo' // 获取实名未通过的用户信息
